export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49')
];

export const server_loads = [];

export const dictionary = {
		"/(connected)/(userland)/(homepage)": [13,[2,3]],
		"/(connected)/admin/br-analyze": [28,[2,5]],
		"/(connected)/admin/br-analyze/[br_id=integer]": [29,[2,5]],
		"/(connected)/admin/dashboard": [30,[2,5,6]],
		"/(connected)/admin/dashboard/data-view": [31,[2,5,6]],
		"/(connected)/admin/sepa-upload": [32,[2,5]],
		"/(connected)/admin/todo": [33,[2,5]],
		"/(offline)/(logo-header)/change-password": [34,[7,8]],
		"/(offline)/(logo-header)/change-password/confirmation": [35,[7,8]],
		"/(connected)/(userland)/check-br-recap/[slug]": [14,[2,3]],
		"/(offline)/(logo-header)/confirmation-required": [36,[7,8]],
		"/(connected)/(userland)/controls-by-offer/detail/[inspection_id=integer]": [15,[2,3,4]],
		"/(connected)/(userland)/controls-by-offer/list": [16,[2,3,4]],
		"/(connected)/(userland)/demande-de-prime-cl/[slug]": [18,[2,3]],
		"/(connected)/(userland)/demande-de-prime-ic/[slug]": [19,[2,3]],
		"/(connected)/(userland)/demande-de-prime/selection-offre": [17,[2,3]],
		"/(connected)/(userland)/demandes-avec-mes-offres-partagees": [20,[2,3]],
		"/(connected)/(userland)/demandes-co-portees/[slug]": [21,[2,3]],
		"/(connected)/(userland)/demandes-en-tant-qu-installateur": [22,[2,3]],
		"/(connected)/(userland)/demandes-en-tant-que-co-porteur": [23,[2,3]],
		"/(offline)/(logo-header)/entity-unverified": [37,[7,8]],
		"/(offline)/(logo-header)/entity-verification-in-progress": [38,[7,8]],
		"/(offline)/identification": [44,[7,9]],
		"/(offline)/inscription": [45,[7,10]],
		"/(offline)/inscription/benefit": [47,[7,10]],
		"/(offline)/inscription/benefit/individual": [48,[7,10,12]],
		"/(offline)/inscription/success": [49,[7,10]],
		"/(offline)/inscription/[slug]": [46,[7,10,11]],
		"/(connected)/(userland)/mes-demandes": [24,[2,3]],
		"/(connected)/(userland)/modification-demande-de-prime/[br_id=integer]": [25,[2,3]],
		"/(offline)/(logo-header)/mot-de-passe-oublie": [39,[7,8]],
		"/(offline)/(logo-header)/mot-de-passe-oublie/confirmation": [40,[7,8]],
		"/(connected)/(userland)/nouveautes": [26,[2,3]],
		"/(connected)/(userland)/organisation": [27,[2,3]],
		"/(offline)/(logo-header)/registration-confirmed": [41,[7,8]],
		"/(offline)/(logo-header)/registration-pending-validation": [42,[7,8]],
		"/(offline)/(logo-header)/service-indisponible": [43,[7,8]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';